"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var MuiInputAdornment = function MuiInputAdornment() {
  return {
    root: {
      '&$positionStart:not($marginDense):not($hiddenLabel)': {
        marginTop: 16
      }
    }
  };
};

var _default = MuiInputAdornment;
exports["default"] = _default;